<script>
export default {
  props: ['className', 'title', 'eventHandler'],
  methods: {
    onAdd() {
      this.btn = document.createElement('button');
      /** eslint-disable-next-line no-useless-concat */
      this.btn.className = `'mapboxgl-ctrl-icon ' + ${this.className}`;
      this.btn.type = 'button';
      this.btn.title = this.title;
      this.btn.onclick = this.eventHandler;

      this.container = document.createElement('div');
      this.container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
      this.container.appendChild(this.btn);

      return this.container;
    },
    onRemove() {
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    },
  },
};
</script>
